// @flow

import type { Items } from '@screens/Finder/Facility/types';

import {
  FILTER_FACILITY_REQUEST,
  FILTER_FACILITY_REQUESTED,
  FILTER_FACILITIES_ERROR,
  CREATE_APPOINTMENT,
  CREATE_APPOINTMENT_SUCCESS,
  CREATE_APPOINTMENT_ERROR,
  RESET_CREATE_APPOINTMENT,
  UPCOMING_APPOINTMENT_REQUEST,
  UPCOMING_APPOINTMENT_REQUESTED,
  UPCOMING_APPOINTMENT_REQUEST_ERROR,
  UPDATED_APPOINTMENT,
  UPDATE_APPOINTMENT,
  UPDATE_APPOINTMENT_ERROR
} from './constants';

import type {
  GetAction,
  CreateAction,
  UpcomingAppointmentData,
  GetAppointmentAction,
  UpdateAction
} from '../types';

export const requestFilterFacilities = (payload: {
  patient_id: string,
  budget_type: string,
  department?: string,
  city?: string,
  facility_id: string,
  page: number,
  per_page?: number,
  department?: string
}): GetAction => ({
  type: FILTER_FACILITY_REQUEST,
  payload
});

export const updateFilterFacilities = (
  data: Items,
  included: Items,
  headers?: any,
  meta?: any
): GetAction => ({
  type: FILTER_FACILITY_REQUESTED,
  data,
  included,
  meta
});

export const errorFilterFacilities = (error: any): GetAction => ({
  type: FILTER_FACILITIES_ERROR,
  error
});

export const createPatientAppointment = (payload: {
  first_name: string,
  last_name: string,
  age: number,
  gender: string,
  department: string,
  medical_notes: string,
  attachment_ids: string,
  illness_kind: any,
  time_from: string,
  time_to: string,
  duration: number,
  billing_type: string,
  treatment_type: any,
  files_attributes: any,
  facility_id: string
}): CreateAction => ({
  type: CREATE_APPOINTMENT,
  payload
});

export const appointmentCreated = (): CreateAction => ({
  type: CREATE_APPOINTMENT_SUCCESS
});

export const errorCreateAppointment = (error: any): CreateAction => ({
  type: CREATE_APPOINTMENT_ERROR,
  error
});

export const resetCreateAppointment = () => ({
  type: RESET_CREATE_APPOINTMENT
});

export const requestUpcomingAppointments = (): GetAppointmentAction => ({
  type: UPCOMING_APPOINTMENT_REQUEST
});

export const updateUpcomingAppointments = (
  data: Array<UpcomingAppointmentData>,
  included: Items
): GetAppointmentAction => ({
  type: UPCOMING_APPOINTMENT_REQUESTED,
  data,
  included
});

export const requestUpcomingAppointmentsError = (error: any): GetAppointmentAction => ({
  type: UPCOMING_APPOINTMENT_REQUEST_ERROR,
  error
});

export const updateAppointment = (payload: { is_active: boolean, id: string }): UpdateAction => ({
  type: UPDATE_APPOINTMENT,
  payload
});

export const updatedAppointment = (id: string): UpdateAction => ({
  type: UPDATED_APPOINTMENT,
  id
});

export const updateAppointmentError = (error: any): UpdateAction => ({
  type: UPDATE_APPOINTMENT_ERROR,
  error
});
